import { render } from "./EOIPrepare.vue?vue&type=template&id=05a7347c"
import script from "./EOIPrepare.vue?vue&type=script&lang=js"
export * from "./EOIPrepare.vue?vue&type=script&lang=js"
script.render = render

export default script